export const SET = 'purchase-order/SET';
export const CLEAR_PAGE_DATA = 'purchase-order/CLEAR_PAGE_DATA';
export const UPDATE_PURCHASE_ORDER = 'purchase-order/UPDATE_PURCHASE_ORDER';
export const APPROVE_COMPLETE = 'purchase-order/APPROVE_COMPLETE';
